import Cookies from 'js-cookie'
import { Dialog  } from 'vant';

const TokenKey = 'token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function resetPwdNeeded() {
  return Cookies.get('resetPwdNeeded')
}

export function checkToken(router){
    var token=getToken();
    console.log(token)
    if(!token){
      Dialog.alert({
        title: '提示',
        message: '登录信息已过期，请重新登录',
      }).then(() => {
        router.replace({path:'/no_login'})
      })
    }
  }



// WEBPACK FOOTER //
// ./src/utils/auth.js